<template>
  <div>
    <div class="row justify-content-center login-bg">
      <div class="col-md-8 col-lg-6 col-xl-5 mt-5">
        <div class="card overflow-hidden pb-5">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome Back !</h5>
                  <p>Sign in to continue to Skote.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/logo/logo.png" alt class="img-fluid w-75" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">

            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{ authError }}</b-alert>

            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>

            <ValidationObserver v-slot="{ handleSubmit }">
              <b-form class="p-2">

                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <b-form-group class="mb-3" id="input-group-1" label="Email" label-for="input-1">
                    <b-form-input id="input-1" v-model="email" type="text" placeholder="Enter email"></b-form-input>

                    <span>{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider name="Password" rules="required|min:6|max:24" v-slot="{ errors }">
                  <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
                    <b-form-input id="input-2" v-model="password" type="password" placeholder="Enter password">
                    </b-form-input>

                    <span>{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>


                <b-form-checkbox class="form-check" id="customControlInline" name="checkbox-1" value="accepted"
                  unchecked-value="not_accepted">
                  Remember me
                </b-form-checkbox>
                <div class="mt-3 d-grid">
                  <b-button class="btn-block" @click.prevent="handleSubmit(istryToLogIn)" type="submit"
                    variant="primary">
                    Log In
                  </b-button>
                </div>
<!--                <div class="mt-4 text-center">-->
<!--                  <h5 class="font-size-14 mb-3">Sign in with</h5>-->

<!--                  <ul class="list-inline">-->
<!--                    <li class="list-inline-item">-->
<!--                      <a href="javascript: void(0);" class="social-list-item bg-primary text-white border-primary">-->
<!--                        <i class="mdi mdi-facebook"></i>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li class="list-inline-item">-->
<!--                      <a href="javascript: void(0);" class="social-list-item bg-info text-white border-info">-->
<!--                        <i class="mdi mdi-twitter"></i>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                    <li class="list-inline-item">-->
<!--                      <a href="javascript: void(0);" class="social-list-item bg-danger text-white border-danger">-->
<!--                        <i class="mdi mdi-google"></i>-->
<!--                      </a>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                </div>-->
<!--                <div class="mt-4 text-center">-->
<!--                  <router-link tag="a" to="/forgot-password" class="text-muted">-->
<!--                    <i class="mdi mdi-lock me-1"></i> Forgot your password?-->
<!--                  </router-link>-->
<!--                </div>-->
              </b-form>
            </ValidationObserver>


          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

<!--        <div class="mt-5 text-center">-->
<!--          <p>-->
<!--            Don't have an account ?-->
<!--            <router-link tag="a" to="/register" class="fw-medium text-primary">Signup now</router-link>-->
<!--          </p>-->
<!--          <p>-->
<!--            © {{ new Date().getFullYear() }} Skote. Crafted with-->
<!--            <i class="mdi mdi-heart text-danger"></i> by Themesbrand-->
<!--          </p>-->
<!--        </div>-->
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>


<script>
  import {
    authMethods,
    authFackMethods,
    notificationMethods,
  } from "@/state/helpers";
  import {
    mapState
  } from "vuex";

  import appConfig from "@/app.config";
  import {
    required,
    email
  } from "vuelidate/lib/validators";
  import {
    loginJWT
  } from '../../../api/endpoints/auth'
  import {
    setToken
  } from '../../../utils/auth'

  /**
   * Login component
   */
  export default {
    page: {
      title: "Login",
      meta: [{
        name: "description",
        content: appConfig.description,
      }, ],
    },
    data() {
      return {
        email: "",
        password: "",
        submitted: false,
        authError: null,
        tryingToLogIn: false,
        isAuthError: false,
      };
    },
    validations: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
    computed: {
      ...mapState("authfack", ["status"]),
      notification() {
        return this.$store ? this.$store.state.notification : null;
      },
    },
    methods: {
      ...authMethods,
      ...authFackMethods,
      ...notificationMethods,
      // Try to log the user in with the username
      // and password they provided.
      istryToLogIn() {
        loginJWT({
          email: this.email,
          password: this.password,
          token_name: "web",
        }).then(res => {
          if(res.data.token === undefined) {
            this.email = ""
            this.password = ""
            return this.openNotification()
          }
          setToken(res.data.token)
          this.$store.dispatch('auth/fetchMe').then(() => {
            this.$router.push('/')
          })
        })
        .catch(error => {
          if(error.response.status === 422) {
            return this.openNotification();
          }
        })
      },
      openNotification() {
        // eslint-disable-next-line no-unused-vars
        const noti = this.$vs.notification({
          progress: 'auto',
          color: 'danger',
          position: 'top-left',
          title: this.$t('errorMessage'),
          text: this.$t('errorLogin')
        })
      }
    },
  };
</script>


<style lang="scss">
  .login-bg {
    width: 100%;
    background-image: url("../../../assets/images/logo/logo.png");
    background-size: 80%;
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>
